import { createSelector } from 'reselect';
import { getOfferIdsByFilter } from './getOfferIdsByFilter';

export const getAvailableFreeCancellationCount = createSelector(getOfferIdsByFilter, (result) => result.freeCancellation?.length || 0);
